<template>
	<div>
		<small-header navbar-index=3></small-header>
		<header-banner></header-banner>
		<learn-center-content></learn-center-content>
		<common-footer></common-footer>
	</div>
</template>

<script>
	import SmallHeader from '@/pages/common/SmallHeader'
	import HeaderBanner from '@/pages/common/HeaderBanner'
	import LearnCenterContent from '@/pages/teach/components/LearnCenterContent'
	import CommonFooter from '@/pages/common/Footer'
	import axios from 'axios'
	export default {
		name: 'TeachCenter',
		components: {
			SmallHeader,
			HeaderBanner,
			LearnCenterContent,
			CommonFooter
		},
		data() {
			return {}
		},
		methods: {},
		mounted() {}
	};
</script>

<style lang="scss" scoped>

</style>